import format from 'date-fns/format'
import { useMemo } from 'react'

export const useFormattedDate = (date: string) =>
  useMemo(() => format(new Date(date), 'MMM. d, y'), [date])
